import Dashboard from 'types/entities/Dashboard';
import { GridSortModel } from '@mui/x-data-grid-pro';
import { SearchParams } from '../../api/ResourceAPI';
import { DashboardTabState } from 'types/enums/DashboardTabState';

const initialParentTab = DashboardTabState.TODO;

export interface DashboardState {
  dashboard_orders: Dashboard[] | null;
  searchParams: SearchParams | null;
  pageHandler: {
    parentTab: DashboardTabState;
    currentPage: number;
    totalPages: number;
    totalItems: number;
  };
  activeOrderId: Dashboard['id'] | null;
  activeLastOrderId: Dashboard['id'] | null;
  offsetTop: number;
  dashboardOrderFilter?: any | null;
  pageSize?: number;
  currentPage?: number;
  sortDashboardTodoOrder?: GridSortModel;
  sortKpiMetricGridData?: GridSortModel;
  kpiMetricGridData?: any[] | null;
  todoOrderCreateList?: any[] | null;

}

export const dashboardState: DashboardState = {
  dashboard_orders: [],
  searchParams: null,
  pageHandler: {
    parentTab: initialParentTab,
    currentPage: 1,
    totalPages: 0,
    totalItems: 0,
  },
  activeOrderId: null,
  activeLastOrderId: null,
  offsetTop: 0,
  dashboardOrderFilter: [],
  pageSize: 10,
  currentPage: 0,
  sortDashboardTodoOrder: [],
  sortKpiMetricGridData: [],
  kpiMetricGridData: [],
  todoOrderCreateList: [],

};
